import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './App';
import './InitializeConfig';
import { configure } from 'mobx';
import 'flat-map-polyfill';

configure({
  enforceActions: 'never',
  reactionRequiresObservable: true
});

const initialStateHolder: InitialStateHolder = { initialState: window.INITIAL_STATE };

const render = (AppComponent: React.ComponentClass, props: InitialStateHolder) => {
  const container = document.getElementById('container');
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(<AppComponent {...props}/>);
  }
};

render(App, initialStateHolder);
